<template>
  <div id="register_box" class="my_container">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>加入绿盟</span>
        <el-divider></el-divider>
      </p>
    </div>
    <div class="rg_form_box">
      <div class="rg_form_box_title">
        <p class="login_title" :class="{active : active.message}" @click="navActive('message')">手机登录</p>
        <p class="login_title" :class="{active : active.password}" @click="navActive('password')">账号登录</p>
      </div>
      <el-form v-show="activeName == 'password'" class="rg_form_box_form" @submit.prevent="submitForm" method="POST" :model="user" :rules="passwordRules" ref="loginPasswordForm" :status-icon=true >
        <el-form-item prop="user_name">
          <el-input type="text" v-model="user.user_name" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="user.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item_fun">
          <div class="lf">
            <el-checkbox label="自动登录" v-model="automatic"></el-checkbox>
          </div>
          <!-- <div class="rt">
            <a>忘记密码?</a>
          </div> -->
        </el-form-item>
        <div class="rg_form_box_form_item">
          <el-dialog
          class="login_dialog"
          title="登录验证"
          :show-close = 'false'
          :visible.sync="dialogPasswordVisible"
          :width="dialogWidth">
            <div class="puzzle-box">
              <puzzle-verification
                width = 230
                height = 110
                deviation = 4
                v-model="puzzleOnOff"
                :puzzleImgList="puzzleImgList"
                blockType="puzzle"
                :onSuccess="handleSuccess"
              />
            </div>
          </el-dialog>
          <el-button slot="reference" type="primary" class="rg_form_box_form_sub" @click="submitForm('loginPasswordForm')">登录</el-button>
          <router-link class="login_a" :to = "{ name: 'Register' }">还没有平台账号？快去注册吧！</router-link>
        </div>
      </el-form>
      <el-form v-show="activeName == 'message'" class="rg_form_box_form" @submit.prevent="submitForm" method="POST" :model="telephone" :rules="mobileRules" ref="loginMessageForm" :status-icon=true>
        <el-form-item prop="tel">
          <el-input type="text" v-model="telephone.tel" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input type="text" v-model="telephone.code" placeholder="请输入验证码">
            <el-button class="send_code_btn" slot="append" @click="obtain"  v-show="isCodeShow">发送验证码</el-button>
            <el-button slot="append" v-show="!isCodeShow" type="text" style="margin-right: 10px;">{{secondsCount}}秒后重发</el-button>
          </el-input>
        </el-form-item>
        <el-form-item class="login_form_item_fun">
          <div class="lf">
            <el-checkbox label="自动登录" v-model="automatic"></el-checkbox>
          </div>
          <!-- <div class="rt">
            <a>忘记密码?</a>
          </div> -->
        </el-form-item>
        <div class="rg_form_box_form_item">
          <el-dialog
          class="login_dialog"
          title="登录验证"
          :show-close = 'false'
          :visible.sync="dialogMessageVisible"
          :width="dialogWidth">
            <div class="puzzle-box">
              <puzzle-verification
                width = 230
                height = 110
                deviation = 4
                v-model="puzzleOnOff"
                :puzzleImgList="puzzleImgList"
                blockType="puzzle"
                :onSuccess="handleSuccess"
              />
            </div>
          </el-dialog>
          <el-button type="primary" class="rg_form_box_form_sub" @click="submitForm('loginMessageForm')">登录</el-button>
          <router-link  class="login_a" :to = "{ name: 'Register' }">还没有平台账号？快去注册吧！</router-link>
        </div>
      </el-form>
      <div class="rg_three_box">
        <div class="rg_three_box_top">
          <el-divider content-position="center">使用第三方账号登录</el-divider>
        </div>
        <div class="rg_three_box_bootom">
          <span class="iconfont icon-weibo" @click="weiboLogin()"></span>
          <span class="iconfont icon-weixin" @click="weixinLogin()"></span>
          <span class="iconfont icon-qq" @click="qqLogin()"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      // 默认导航选中
      activeName: 'message',
      active: {
        message: true,
        password: false
      },
      // 倒计秒数初始化定义
      secondsCount: 0,
      // 是否显示发送验证码按钮
      isCodeShow: true,
      // 是否自动登录
      automatic: true,
      user: {
        user_name: '',
        password: '',
        type: 1
      },
      telephone: {
        tel: '',
        code: '',
        type: 2
      },
      passwordRules: {
        user_name: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 3, max: 16, message: '账号格式错误', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regexp = /^[A-Za-z]{1}[A-Za-z0-9_-]{3,15}$/
              if (!regexp.test(value)) {
                callback(new Error('账号格式错误'))
              } else {
                callback()
              }
            }
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      mobileRules: {
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.length > 11 || value.length < 8) {
                callback(new Error('长度必须为11数字'))
              } else {
                const regexp = /^1[3456789]\d{9}$/
                if (!regexp.test(value)) {
                  callback(new Error('电话号码格式不对'))
                } else {
                  callback()
                }
              }
            }
          }
        ],
        code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ]
      },
      dialogPasswordVisible: false, // 控制是否显示
      dialogMessageVisible: false,
      dialogWidth: '260px', // 控制弹出窗宽度
      puzzleOnOff: false, // 控制图片验证是否显示
      puzzleImgList: [
        require('../../assets/img/index/1-01.jpeg'),
        require('../../assets/img/index/1-02.jpeg'),
        require('../../assets/img/index/1-03.jpeg')
      ],
      subInfo: {} // 最终提交的数据
    }
  },
  mounted () {
    // 绑定enter事件
    this.enterKeyup()
  },
  destroyed () {
    // 销毁enter事件
    this.enterKeyupDestroyed()
  },
  methods: {
    // 导航栏切换
    navActive (text) {
      this.activeName = text
      if (text === 'password') {
        this.active.password = true
        this.active.message = false
      } else {
        this.active.password = false
        this.active.message = true
      }
    },
    // 获取验证码
    async obtain () {
      const vueThat = this
      if (vueThat.telephone.tel.length > 11 || vueThat.telephone.tel.length < 8) {
        vueThat.$message.error('请填写正确的手机号码！')
      } else {
        const regexp = /^1[3456789]\d{9}$/
        if (!regexp.test(vueThat.telephone.tel)) {
          vueThat.$message.error('请填写正确的手机号码！')
        } else {
          vueThat.secondsCount = 60
          // 切换倒计时按钮
          vueThat.isCodeShow = false
          // 倒计时函数
          const timer = setInterval(function () {
            vueThat.secondsCount--
            if (vueThat.secondsCount <= 0) {
              clearInterval(timer)
              vueThat.isCodeShow = true
            }
          }, 1000)
          await vueThat.$store.dispatch('user/send', { number: vueThat.telephone.tel })
        }
      }
    },
    // 图形验证通过后
    handleSuccess () {
      this.formAxios()
    },
    // 表单验证
    submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          if (vueThat.activeName === 'password') {
            vueThat.dialogPasswordVisible = true
            vueThat.subInfo = vueThat.user
          } else if (vueThat.activeName === 'message') {
            vueThat.dialogMessageVisible = true
            vueThat.subInfo = vueThat.telephone
          }
        } else {
          return false
        }
      })
    },
    // 发起表单提交
    formAxios () {
      const vueThat = this
      const userInfo = vueThat.subInfo
      try {
        // 消除回车键
        this.enterKeyupDestroyed()
        vueThat.$store.dispatch('user/login', userInfo)
          .then(async function (rs) {
            if (rs.data.code === 200) {
              vueThat.$store.commit('user/updateUserInfo', {
                id: rs.data.data.user_id,
                name: rs.data.data.user_name,
                authorization: rs.data.data.token,
                sig: rs.data.data.sig,
                is_authentication: rs.data.data.is_authentication,
                portrait: rs.data.data.portrait,
                automatic: vueThat.automatic
              })
              vueThat.$alert('登录成功', '温馨提示', {
                type: 'success',
                iconClass: 'iconfont icon-icon_richeng_btn_pass',
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  if (vueThat.activeName === 'password') {
                    vueThat.dialogPasswordVisible = false
                  } else if (vueThat.activeName === 'message') {
                    vueThat.dialogMessageVisible = false
                  }
                  vueThat.webIM.login({ userID: rs.data.data.user_id + '', userSig: rs.data.data.sig })
                    .then(function (imResponse) {
                      console.log(imResponse.data) // 登录成功
                    }).catch(function (imError) {
                      console.warn('login error:', imError) // 登录失败的相关信息
                    })
                  if (vueThat.$store.state.other.oldUrl === '') {
                    vueThat.$router.push({ name: 'Home' })
                  } else {
                    vueThat.$router.go(-1)
                  }
                }
              })
            } else {
              // 关闭图片验证
              if (vueThat.activeName === 'password') {
                vueThat.dialogPasswordVisible = false
                // 将密码重置
                vueThat.user.password = ''
              } else if (vueThat.activeName === 'message') {
                vueThat.dialogMessageVisible = false
                // 将手机验证码重置
                vueThat.telephone.code = ''
              }
              // 绑定enter事件
              vueThat.enterKeyup()
            }
          })
      } catch (e) {}
    },
    // 监控回车键
    enterKey (event) {
      const componentName = this.$options.name
      if (componentName === 'Login') {
        const code = event.keyCode
          ? event.keyCode
          : event.which
            ? event.which
            : event.charCode
        if (code === 13) {
          if (this.activeName === 'password') {
            this.submitForm('loginPasswordForm')
          } else {
            this.submitForm('loginMessageForm')
          }
        }
      }
    },
    // 消除回车键
    enterKeyupDestroyed () {
      document.removeEventListener('keyup', this.enterKey)
    },
    // 添加回车键
    enterKeyup () {
      document.addEventListener('keyup', this.enterKey)
    },
    // 微信登录
    weixinLogin () {
      const url = 'http://' + window.location.host + '/weChatCallback'
      window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxb7460c3667c6e927&redirect_uri=' + this.mycommon.getUrlEncode(url) + '&response_type=code&scope=snsapi_login'
    },
    // 微博登录
    weiboLogin () {
      const url = 'http://' + window.location.host + '/weiboCallback'
      window.location.href = 'https://api.weibo.com/oauth2/authorize?client_id=3265476805&response_type=code&redirect_uri=' + url
    },
    // qq登录
    qqLogin () {
      this.$message.error('暂未开通QQ快捷登录功能，请使用其他快捷登录！')
    }
  }
}
</script>

<style scoped="scoped">
.puzzle-box .puzzle-container{
  display: block !important;
}
</style>
